module.exports = __webpack_public_path__ + "static/media/MAIN-TITLE.33c0ab6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/MAIN-TITLE.png
// module id = 261
// module chunks = 0